
import { MissingInformationException } from './../exceptions/MissingInformationException';
import { AccountInformationRequest } from './../requests/AccountInformationRequest';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { ChosenPlan } from '../requests/ChosenPlanRequest';
import { ConditionRequest } from '../requests/SaveConditionRequest';
import { RegistrationRequest } from '../requests/RegistrationRequest';
import { AddressRequest } from '../requests/AddressRequest';
import { AccessToken, Account } from '../models';
import moment from 'moment';
export class SubscriptionService{
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    private static chosenPlan:ChosenPlan;
    private static accountInformation:AccountInformationRequest | null;
    private static address:AddressRequest;
    private static conditions:string;
    private static allowMarketing:boolean = false;
    public static saveChoosenPlan(request:ChosenPlan):void{
        this.chosenPlan = request;
    }
    public static getChosenPlan():ChosenPlan{
        return this.chosenPlan;
    }
    public static saveAccountInformation(request:AccountInformationRequest | null):void{
        this.accountInformation = request;
    }
    public static  getAccountInformation():AccountInformationRequest | null{
        return this.accountInformation;
    }
    public static saveAddress(request:AddressRequest):void{
        this.address = request;
    }
    public static  getAddress():AddressRequest{
        return this.address;
    }
    public static saveConditions(request:ConditionRequest){
        this.conditions = request.conditions;
        this.allowMarketing = request.allow_marketing;
    }
    public  static async registerAccount(langauage:string):Promise<any>{
        if(!this.accountInformation?.password){
           throw new MissingInformationException('Missing account information');
        }
        if(!this.conditions){
            throw new MissingInformationException("Missing conditions")
        }
        if(!this.address || this.address.country_id ==-1){
            throw new MissingInformationException("Missing country")
        }
        let registrationRequest : RegistrationRequest ={
            prename :this.accountInformation.prename,
            surname : this.accountInformation.surname,
            email:this.accountInformation.email,
            //mobile:this.accountInformation.phone_code+this.accountInformation.mobile,
            password:this.accountInformation.password,
            //plan_id : this.chosenPlan.plan_id,
            
            //payment_cycle:this.chosenPlan.payment_cycle,
            conditions:this.conditions,
            allow_marketing:this.allowMarketing,
            referral_code:this.accountInformation.referral_code?this.accountInformation.referral_code:undefined,
            preferred_language:langauage
        };
        if(this.address){
            registrationRequest.country_id=this.address.country_id,
            registrationRequest.line1 = this.address.line1;
            registrationRequest.line2 = this.address.line2?this.address.line2:undefined;
            registrationRequest.postal_code = this.address.postal_code;
            registrationRequest.city = this.address.city;
            registrationRequest.region = this.address.region;
        }
        this.headers.addLocationHeader(langauage);
        const json = await this.requester.post(this.links.registerCustomer(),this.headers,registrationRequest);
        this.accountInformation = null;
        const expireDate = moment().add(json.success.expires_in,'s').format();
        const accessToken:AccessToken = {
            token:json.success.access_token,
            expire:expireDate
        };
        const refreshToken:string = json.success.refresh_token;
        const secret:string = json.success.secret;
        const account:Account = json.success.account;
        return {
            accessToken:accessToken,
            refreshToken:refreshToken,
            secret:secret,
            account:account
        }
    }
}
